export const RUNNING_PATIENT_STATUS_ENCOUNTER_STATUSES = [
  "draft",
  "submitted",
  "triaged",
  "seen",
  "expected",
] as const;

export type PatientStatusEncounterSummary = {
  id?: string;
  status?: string | null;
  created?: string | number | null;
  arrived?: string | number | null;
  expected?: string | number | null;
  nextObsDue?: string | number | null;
  source?: string | null;
};

const runningStatusSet = new Set<string>(RUNNING_PATIENT_STATUS_ENCOUNTER_STATUSES);

export const isRunningPatientStatusEncounter = (encounter: PatientStatusEncounterSummary): boolean => (
  runningStatusSet.has(String(encounter.status || ""))
);

export const getOtherRunningPatientStatusEncounters = (
  encounters: PatientStatusEncounterSummary[] | undefined,
  currentEncounterId?: string,
): PatientStatusEncounterSummary[] => {
  if (!Array.isArray(encounters)) return [];
  return encounters.filter((encounter) => (
    isRunningPatientStatusEncounter(encounter) &&
    (!currentEncounterId || encounter.id !== currentEncounterId)
  ));
};

export const formatPatientStatusEncounterStatus = (status: string | null | undefined): string => {
  const statusValue = String(status || "").trim();
  if (!statusValue) return "Encounter";
  if (statusValue === "expected") return "Expected";
  return statusValue.charAt(0).toUpperCase() + statusValue.slice(1);
};
